import type { ProvideKeycloakOptions } from 'keycloak-angular';

export const KeycloakConfig = (keycloakHost: string, realm: string) => {
  return {
    config: {
      url: `${keycloakHost}/auth`,
      realm: realm || 'kwh-courier',
      clientId: 'courier-ui',
    },
    loadUserProfileAtStartUp: true,
    initOptions: {
      checkLoginIframe: false,
      onLoad: 'login-required',
    },
  } as ProvideKeycloakOptions;
};
